import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { getPermissionsForMenu } from "../../Utils/RolePermissions";

import Table from "../../../../core/pagination/datatable";
import AddHostAsset from "./AddHostAsset";
import EditHostAsset from "./EditHostAsset";
import ViewHostAsset from "./ViewHostAsset";

import { Select, Spin } from "antd";
import {
  getApiBaseUrl,
  GET_AHU_MACHINES_LIST,
  GET_BLOCKS,
} from "../../Config/Config";
const { Option } = Select;

const HostAssets = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const menuPath = pathSegments[pathSegments.length - 1];
  const { Write, Delete, Export, Read } = getPermissionsForMenu(menuPath);
  const hasActions = Write || Delete || Export;

  const [ahuMachines, setAhuMachines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [blocks, setBlocks] = useState([]);
  const [selectedBlock, setSelectedBlock] = useState(0);

  const fetchAHUMachines = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${getApiBaseUrl()}${GET_AHU_MACHINES_LIST}?location=${selectedBlock}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setAhuMachines(data?.ResultData || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAHUMachines();
  }, [selectedBlock]);

  const [editData, setEditData] = useState(null);
  const columns = [
    {
      title: "AHU ID",
      dataIndex: "Code",
      key: "Code",
      sorter: (a, b) => (a.Code || "").localeCompare(b.Code || ""),
    },
    {
      title: "Description",
      dataIndex: "Description",
      key: "Description",
      sorter: (a, b) =>
        (a.Description || "").localeCompare(b.Description || ""),
      render: (text) => (
        <span title={text}>
          {text?.length > 15 ? `${text.slice(0, 15)}...` : text}
        </span>
      ),
    },

    {
      title: "Department",
      dataIndex: "Department",
      key: "Department",
      sorter: (a, b) => (a.Department || "").localeCompare(b.Department || ""),
    },
    {
      title: "Manufacturer",
      dataIndex: "Manufacturer",
      key: "Manufacturer",
      sorter: (a, b) =>
        (a.Manufacturer || "").localeCompare(b.Manufacturer || ""),
    },
    {
      title: "Model No",
      dataIndex: "ModelNo",
      key: "ModelNo",
      sorter: (a, b) => (a.ModelNo || "").localeCompare(b.ModelNo || ""),
    },
    {
      title: "Capacity",
      dataIndex: "Capacity",
      key: "Capacity",
      sorter: (a, b) =>
        (parseFloat(a.Capacity) || 0) - (parseFloat(b.Capacity) || 0),
    },
    {
      title: "No. of Filters",
      dataIndex: "Sparescount",
      key: "Sparescount",
      sorter: (a, b) =>
        (parseInt(a.Sparescount) || 0) - (parseInt(b.Sparescount) || 0),
    },
  ];

  {
    hasActions &&
      columns.push({
        title: "Action",
        dataIndex: "action",
        key: "action",
        render: (_, record) => (
          <div className="action-table-data">
            <div className="edit-delete-action d-flex align-items-center">
              {Write && (
                <Link
                  to="#"
                  className="me-2 p-2"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightEditHostAsset"
                  aria-controls="offcanvasRightEditHostAsset"
                  title="Edit"
                  onClick={() => setEditData(record)}
                >
                  <i className="feather-edit text-info" data-feather="edit"></i>
                </Link>
              )}
              {Read && (
                <Link
                  to="#"
                  className="me-2 p-2"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightViewHostAsset"
                  aria-controls="offcanvasRightViewHostAsset"
                  title="Edit"
                  onClick={() => setEditData(record)}
                >
                  <i className="feather-eye text-info" data-feather="eye"></i>
                </Link>
              )}
            </div>
          </div>
        ),
      });
  }

  const fetchBlocks = async () => {
    try {
      const response = await fetch(`${getApiBaseUrl()}${GET_BLOCKS}`);
      const result = await response.json();

      if (result?.ResultData) {
        setBlocks(result.ResultData);
      }
    } catch (err) {
      console.error("Error fetching blocks:", err);
    }
  };

  useEffect(() => {
    fetchBlocks();
  }, []);

  const handleBlockChange = (blockId) => {
    setSelectedBlock(blockId);
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    AHU Machines List
                  </h4>
                </ol>
              </nav>
              <h6>Manage AHU Machines</h6>
            </div>
          </div>

          {Write && (
            <div className="page-btn">
              <Link
                to="#"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightAddHostAsset"
                aria-controls="offcanvasRightNewSupplier"
                className="btn btn-success btn-sm"
              >
                <i className="ti ti-circle-plus fs-4"></i>
              </Link>
            </div>
          )}
        </div>

        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
            <div className="search-set m-3"></div>
            <div className="d-flex align-items-center flex-wrap gap-3 my-xl-auto right-content">
              <div style={{ minWidth: "250px" }}>
                <label className="fw-bold mb-1 d-block">Select Block:</label>
                <Select
                  style={{ width: "100%" }}
                  value={selectedBlock === 0 ? 0 : selectedBlock} // Ensures "All" is shown when value is 0
                  onChange={handleBlockChange}
                  placeholder="Select Block"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.children
                      ?.toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  <Option value={0}>All</Option>
                  {blocks.map((block) => (
                    <Option key={block.BlockId} value={block.BlockId}>
                      {block.BlockName}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {loading ? (
                <div className="text-center my-4">
                  <Spin size="large" />
                  <p>Loading data...</p>
                </div>
              ) : ahuMachines?.length > 0 ? (
                <Table columns={columns} dataSource={ahuMachines} rowKey="id" />
              ) : (
                <p className="text-center my-4">No data available</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <>
        <AddHostAsset />
        <EditHostAsset formData={editData} />
        <ViewHostAsset formData={editData} />
      </>
    </div>
  );
};

export default HostAssets;
